export const signUpValidator = values => {
  let errors = {}
  if (!values.name) {
    errors.name = 'Field is required'
  } else if (!/^[a-zA-Z-' ]+$/.test(values.name)) {
    errors.name = 'Enter a valid name'
  }
  if (!values.password) {
    errors.password = 'Field is required'
  } else if (!/^.{6,}$/.test(values.password)) {
    errors.password = 'Password must contain minimum 6 characters'
  }
  if (!values.email) {
    errors.email = 'Field is required'
  } else if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(values.email)) {
    errors.email = 'Enter a valid email address'
  }
  return errors
}
export const loginValidator = values => {
  let errors = {}

  if (!values.password) {
    errors.password = 'Field is required'
  }
  if (!values.email) {
    errors.email = 'Field is required'
  } else if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(values.email)) {
    errors.email = 'Enter a valid email address'
  }
  return errors
}
export const resetEmailValidator = values => {
  let errors = {}
  if (!values.email) {
    errors.email = 'Field is required'
  } else if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(values.email)) {
    errors.email = 'Enter a valid email address'
  }
  return errors
}
export const feedBackValidator = values => {
  let errors = {}
  if (!values.text) {
    errors.text = 'Field is required'
  }
  return errors
}

export const resetPasswordValidator = values => {
  let errors = {}
  if (!values.password) {
    errors.password = 'Field is required'
  } else if (!/^.{6,}$/.test(values.password)) {
    errors.password = 'Password must contain minimum 6 characters'
  }
  return errors
}

export const addList = values => {
  let errors = {}
  if (!values.title) {
    errors.title = 'Field is required'
  }
  return errors
}
export const editProfileValidator = values => {
  let errors = {}
  if (!values.name) {
    errors.name = 'Field is required'
  } else if (!/^[a-zA-Z-' ]+$/.test(values.name)) {
    errors.name = 'Enter a valid name'
  }
  return errors
}
export const zipCodeValidator = values => {
  let errors = {}
  if (!values.zipcode) {
    errors.zipcode = 'Field is required'
  } else if (!/^\d+$/.test(values.zipcode)) {
    errors.zipcode = 'Enter valid zipcode'
  }
  return errors
}
export const changePasswordValidator = values => {
  let errors = {}
  if (!values.oldPassword) {
    errors.oldPassword = 'Field is required'
  }
  if (!values.newPassword) {
    errors.newPassword = 'Field is required'
  } else if (!/^.{6,}$/.test(values.newPassword)) {
    errors.newPassword = 'Password must contain minimum 6 characters'
  }
  if (!values.confirmNewPassword) {
    errors.confirmNewPassword = 'Field is required'
  } else if (values.newPassword !== values.confirmNewPassword) {
    errors.confirmNewPassword = 'Passwords mismatch'
  }
  return errors
}

export const changeUpcValidator = values => {
  let errors = {}
  if (!values.upcCode) {
    errors.upcCode = 'Field is required'
  } else if (!/^.{6,}$/.test(values.upcCode)) {
    errors.upcCode = 'upc code must contain minimum 6 characters'
  }
  if (!values.confirmUpcCode) {
    errors.confirmUpcCode = 'Field is required'
  } else if (values.upcCode !== values.confirmUpcCode) {
    errors.confirmUpcCode = 'upc code mismatch'
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/utlis/validators.js